import * as THREE from 'three';
import {textCenter} from "../Text/TextCenter";
import {Server} from "../../../../../../services/model/server.model";

export function ServerPlus(
	scene: THREE.Scene,
	x: number,
	z: number,
	qte: number,
	servers: Server[],
): void {
	const group = new THREE.Group();

	// // Créer le plan principal
	// const planeRound: Mesh = Plane(1.3, 1.3, .5, 0xA890F3);
	// group.add(planeRound);
	//
	// // Créer la bordure avec extrusion
	// const border: Object3D = PlaneBorder(1.3, 1.3, .5, 0xA890F3, 0.01, true);
	// group.add(border);

	// Création avec une map
	const planeGeo = new THREE.PlaneGeometry(1.3, 1.3, );
	const texture = new THREE.TextureLoader().load('assets/three/TEXTURE/ICON_SERVER_PLUS.png' );
	const planeMaterial = new THREE.MeshBasicMaterial( { map:texture, transparent:true, color: 0xA890F3 } );
	const plane = new THREE.Mesh(planeGeo, planeMaterial);
	group.add(plane);

	// Enlevé les 7 premiers servers
	const newServers = servers.slice(7);

	//userData
	plane.layers.set(1);
	plane.userData.modelType = "PlusServer";
	plane.userData.data = newServers;

	// Naming
	const serverNumber: string = `+${qte - 7}`;
	textCenter(serverNumber, (textMesh: THREE.Mesh): void => {
		group.add(textMesh);
	},0.35, 0xA890F3, 0.01);

	group.rotation.x = -Math.PI / 2;
	group.position.set(x, 0.001, z);

	scene.add(group);
}
